<template>
  <div
    class="header-responsive"
    :class="ratio"
  >
    <div
      v-if="headerBackground"
      class="bg"
    >
      <picture class="d-flex hero-picture">
        <img
          :src="headerBackground"
          :class="imagePosition"
          :alt="headerTitleHtml"
          class="img-full hero-picture-img hero-image"
        >
      </picture>
    </div>

    <div class="content dark">
      <div class="header">
        <h1
          v-if="purify"
          v-dompurify-html="$t(headerTitleHtml)"
          class="h2-xs"
        />
        <!-- eslint-disable vue/no-v-html-->
        <h1
          v-else
          class="h2-xs"
          v-html="headerTitleHtml"
        />
        <!-- eslint-enable vue/no-v-html-->
        <h2
          v-if="headerSubtitleHtml"
          v-dompurify-html="$t(headerSubtitleHtml)"
          class="h2-xs"
        />
      </div>
      <div
        v-if="headerLinks.length > 0"
        class="row row-tight justify-content-center"
      >
        <div
          v-for="(item, index) in headerLinks"
          :key="index"
          class="col-lg-3 col-md-4"
        >
          <p>
            {{ $t(item.teaser) }}
          </p>
          <a
            v-if="item.href && typeof item.href === 'string' && item.href.search(/^(http|\/\/)/) !== -1"
            :href="item.href"
            :target="item.target"
            :class="`btn ${(item.primary) ? 'btn-primary' : 'btn-line'}`"
          >
            {{ $t(item.title) }}
          </a>
          <router-link-simple
            v-else-if="item.href"
            :to="item.href"
            class="mb-3"
            :class="`btn ${(item.primary) ? 'btn-primary' : 'btn-line'}`"
          >
            {{ $t(item.title) }}
          </router-link-simple>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouterLinkSimple from 'components/RouterLinkSimple.vue';

export default {
  name: 'HeaderResponsive',
  components: {
    RouterLinkSimple,
  },
  props: {
    purify: {
      type: Boolean,
      default: true,
    },
    headerTitleHtml: {
      type: String,
      default: '',
    },
    headerSubtitleHtml: {
      type: String,
      default: '',
    },
    headerBackground: {
      type: String,
      default: '',
    },
    ratio: {
      type: String,
      default: '',
    },
    headerLinks: {
      type: Array,
      default: () => [],
    },
    imagePosition: {
      type: String,
      default: 'auto',
    },
  },
};
</script>


<style lang="scss" scoped>
.hero-picture {
  width: 100%;
  height: 50vh;
  min-height: 100%;
  .hero-picture-img {
    object-fit: cover;
  }
}
 .header-responsive{
    h1,
    .h1 {
      margin: 0 0 0.15em;
      color: #fff;
      filter: drop-shadow(1px 1px 10px rgba(0,0,0,.2));

      @include font_bold;
      @include text_shadow_strong;
      @include header_search_heartbeat;
    }

    @keyframes heartbeat {
      0% {
        transform: scale(1);
      }

      20% {
        transform:
          scale(1.05) translateX(0%) translateY(0%);
      }

      40% {
        transform:
          scale(1.15) translateX(0%) translateY(0%);
      }
    }

  /deep/  svg {
      animation: heartbeat 1.5s infinite;
      overflow: visible;
    }
 }
</style>
